import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppMainComponent } from './app.main.component';
import { PermissionService } from './service/permission.service';
import { ObjectNames, productsModuleObjectNames, purchasesModuleObjectNames, salesOrderModuleObjectNames, serialDetailModuleObjectNames } from './shared/constants';
import { ConfigurationService } from './configurations/configurationService';
import { TranslocoService } from '@ngneat/transloco';
import { Subscription } from 'rxjs';
import { ModuleWidgetService } from './modules/shared/services/dynamic-table/module-widget.service';
import { DynamicTableWidgetService } from './modules/shared/services/dynamic-table/dynamic-table-widget.service';
import { DynamicTableModuleWidgetM } from './modules/shared/models/dynamic-table/dynamic-table-module-widget.model';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit, OnDestroy {

    model: any[];
    reportPermissionData: any[];
    menu: any[] = [];
    menuTranslate = {     
        Leads: "Leads",
        Contacts: "Contacts",
        ContactsV2: "ContactsV2",
        Accounts: "Accounts",
        Opportunities: "Opportunities",
        Inventory: "Inventory",
        Quotation: "Quotation",
        Sales: "Sales",
        Invoice: "Invoice",
        Products: "Products",
        Purchases: "Purchases",
        Locations: "Locations",
        SerialDetails: "Serial Details",
        PosStore: "Point of Sale (POS)",
        Finance: "Finance",
        ChartOfAccounts: "ChartOfAccounts",
        Journals: "Journals",
        FSM: "FSM",
        Territory: "Territory",
        Routes: "Routes",
        Questionnaire: "Questionnaire",
        Misc: "Misc.",
        Workflow: "Workflow",
        Campaign: "Messaging",
        SavedSearches: "Saved Searches",
        MassEdit: "Mass Edit",
        Goals: "Sales Quota",
        Cases: "Cases",
        Reports: "Reports",
        Configurations: "Configurations",
        Workspace: "Workspace",
        Workbook: "Custom",
    }
    private userPermissionSubscription: Subscription;
    private moduleWidgetSubscription: Subscription;

    constructor(
        public app: AppMainComponent,
        private permissionService: PermissionService,
        private configurationService: ConfigurationService,
        private translocoService: TranslocoService,
        private moduleWidgetService: ModuleWidgetService,
        private dynamicTableWidgetService: DynamicTableWidgetService
    ) {
        this.getTranslatedValue();
        
        // Subscribe to workbook changes to auto-update menu
        this.moduleWidgetSubscription = this.moduleWidgetService.getModuleWidgets().subscribe(moduleWidgets => {
            this.updateMenuWithWorkbooks(moduleWidgets);
        });
        
        // Load initial data
        this.moduleWidgetService.forceRefreshWidgets();
    }

    // Will take from local storage

    getTranslatedValue() {
        this.translocoService.selectTranslate('Menu.Leads').subscribe((data) => {
            this.menuTranslate.Leads = data;
        });

        this.translocoService.selectTranslate('Menu.Accounts').subscribe((data) => {
            this.menuTranslate.Accounts = data;
        });

        this.translocoService.selectTranslate('Menu.Opportunities').subscribe((data) => {
            this.menuTranslate.Opportunities = data;
        });

        this.translocoService.selectTranslate('Menu.Inventory').subscribe((data) => {
            this.menuTranslate.Inventory = data;
        });

        this.translocoService.selectTranslate('Menu.Quotation').subscribe((data) => {
            this.menuTranslate.Quotation = data;
        });

        this.translocoService.selectTranslate('Menu.Sales').subscribe((data) => {
            this.menuTranslate.Sales = data;
        });

        this.translocoService.selectTranslate('Menu.Invoice').subscribe((data) => {
            this.menuTranslate.Invoice = data;
        });

        this.translocoService.selectTranslate('Menu.Products').subscribe((data) => {
            this.menuTranslate.Products = data;
        });

        this.translocoService.selectTranslate('Menu.Purchases').subscribe((data) => {
            this.menuTranslate.Purchases = data;
        });

        this.translocoService.selectTranslate('Menu.Locations').subscribe((data) => {
            this.menuTranslate.Locations = data;
        });

        this.translocoService.selectTranslate('Menu.Finance').subscribe((data) => {
            this.menuTranslate.Finance = data;
        });

        this.translocoService.selectTranslate('Chart of Accounts').subscribe((data) => {
            this.menuTranslate.ChartOfAccounts = data;
        });

        this.translocoService.selectTranslate('Journals').subscribe((data) => {
            this.menuTranslate.Journals = data;
        });

        this.translocoService.selectTranslate('FSM').subscribe((data) => {
            this.menuTranslate.FSM = data;
        });

        this.translocoService.selectTranslate('Menu.Territory').subscribe((data) => {
            this.menuTranslate.Territory = data;
        });

        this.translocoService.selectTranslate('Menu.Routes').subscribe((data) => {
            this.menuTranslate.Routes = data;
        });

        this.translocoService.selectTranslate('Menu.Questionnaire').subscribe((data) => {
            this.menuTranslate.Questionnaire = data;
        });

        this.translocoService.selectTranslate('Misc.').subscribe((data) => {
            this.menuTranslate.Misc = data;
        });

        this.translocoService.selectTranslate('Sales Quota').subscribe((data) => {
            this.menuTranslate.Goals = data;
        });

        this.translocoService.selectTranslate('Menu.Cases').subscribe((data) => {
            this.menuTranslate.Cases = data;
        });

        this.translocoService.selectTranslate('Menu.Reports').subscribe((data) => {
            this.menuTranslate.Reports = data;
        });

        this.translocoService.selectTranslate('Menu.Configurations').subscribe((data) => {
            this.menuTranslate.Configurations = data;
        });

        this.translocoService.selectTranslate('Menu.Workbook').subscribe((data) => {
            this.menuTranslate.Workbook = data;
        });
    }

    ngOnInit() {
        this.userPermissionSubscription = this.permissionService.getPermissionUpdatedSignal().subscribe((res) => {
            let menuItems: any[] = [];
            let userPermissions: any = [];
            if (res.length == 0) {
                userPermissions = this.permissionService.getPemrissionData();
            } else {
                userPermissions = res;
            }
            const isPointOfsale = userPermissions.some(obj => obj.objectName == ObjectNames.pointOfSale && obj.permissions.some(permission => permission.statusId === 1));

            const reportPermissions = this.permissionService.getReportsPermissionByChannel();
            const reportPermission = reportPermissions?.find(report => report?.permissions.find(obj => obj.statusId == 1));

            if (reportPermissions.length > 0)
                this.app.setDashboardWidgets(reportPermissions, userPermissions);

            const streamUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.STREAM);
            const streamMenuPermission = streamUserPermission ? (streamUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;
            menuItems.push({
                routerLink: ['/'],
                icon: 'fa fa-fw fa-home',
            });

            const dashboardPermission = userPermissions.find(obj => obj.objectName === ObjectNames.DASHBOARD);
            const dashboardMenuPermission = dashboardPermission ? (dashboardPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

            const leadUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.LEAD);
            const leadMenuPermission = leadUserPermission ? (leadUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;
            if (leadMenuPermission) {
                menuItems.push({ label: this.menuTranslate.Leads, routerLink: ['/leads'] });
            }

            const contactUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CONTACT);
            const contactMenuPermission = contactUserPermission ? (contactUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;
            
            const accountUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.ACCOUNT);
            const accountMenuPermission = accountUserPermission ? (accountUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;
            if (accountMenuPermission) {
                menuItems.push({ label: this.menuTranslate.Accounts, routerLink: ['/accounts'] });
            }

            const opportunityUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.OPPORTUNITY);
            const opportunityMenuPermission = opportunityUserPermission ? (opportunityUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;
            if (opportunityMenuPermission) {
                menuItems.push({ label: this.menuTranslate.Opportunities, routerLink: ['/opportunities'] })
            }

            const gaolsUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.GOAL);
            const gaolsMenuPermission = gaolsUserPermission ? (gaolsUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;
            if (gaolsMenuPermission) {
                menuItems.push({ label: this.menuTranslate.Goals, routerLink: ['/sales-quota'] })
            }

            const casesUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CASES);
            const casesMenuPermission = casesUserPermission ? (casesUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;
            if (casesMenuPermission) {
                menuItems.push({ label: this.menuTranslate.Cases, routerLink: ['/cases'] });
            }

            //fsm
            const territoryUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.TERRITORY);
            const territoryMenuPermission = territoryUserPermission ? (territoryUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

            const routeUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.ROUTE);
            const routeMenuPermission = routeUserPermission ? (routeUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

            const questionnaireUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.QUESTIONNAIRE);
            const questionnaireMenuPermission = questionnaireUserPermission ? (questionnaireUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

            if (territoryMenuPermission || routeMenuPermission || questionnaireMenuPermission) {
                const fsmMenu = {
                    label: this.menuTranslate.FSM, items: [] as any[]
                }
                if (territoryMenuPermission) {
                    fsmMenu.items.push({ label: this.menuTranslate.Territory, routerLink: ['/territory'] })
                }
                if (routeMenuPermission) {
                    fsmMenu.items.push({ label: this.menuTranslate.Routes, routerLink: ['/routes'] })
                }
                if (questionnaireMenuPermission) {
                    fsmMenu.items.push({ label: this.menuTranslate.Questionnaire, routerLink: ['/questionnaire'] })
                }
                menuItems.push(fsmMenu);
            }

            //inventory
            const quotationUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.QUOTATION);
            const quotationMenuPermission = quotationUserPermission ? (quotationUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

            const salesOrderMenuPermission = userPermissions?.some(obj => salesOrderModuleObjectNames?.includes(obj.objectName) && obj.permissions?.some(permission => permission.statusId === 1));
            const producyMenuPermission = userPermissions?.some(obj => productsModuleObjectNames?.includes(obj.objectName) && obj.permissions?.some(permission => permission.statusId === 1));
            const purchaseMenuPermission = userPermissions?.some(obj => purchasesModuleObjectNames?.includes(obj.objectName) && obj.permissions?.some(permission => permission.statusId === 1));
            const isSerialDetails = userPermissions?.some(obj => serialDetailModuleObjectNames?.includes(obj.objectName) && obj.permissions?.some(permission => permission.statusId === 1));
            const wareHouseMenuPermission = userPermissions?.some(obj => obj.objectName === ObjectNames.WAREHOUSE && obj.permissions?.some(permission => permission.statusId === 1));

            if (quotationMenuPermission || salesOrderMenuPermission  || producyMenuPermission || purchaseMenuPermission || wareHouseMenuPermission) {
                const moreMenu = {
                    label: this.menuTranslate.Inventory, items: [] as any[]
                }
                if (quotationMenuPermission) {
                    moreMenu.items.push({ label: this.menuTranslate.Quotation, routerLink: ['/quotation'] })
                }
                if (salesOrderMenuPermission) {
                    moreMenu.items.push(
                        {
                            label: this.menuTranslate.Sales, items: this.getSubMenu(userPermissions)
                        }
                    )
                }
                if (producyMenuPermission) {
                    moreMenu.items.push(
                        {
                            label: this.menuTranslate.Products, items: this.getProductMenu(userPermissions)
                        }
                    )
                }
                if (purchaseMenuPermission) {
                    moreMenu.items.push(
                        {
                            label: this.menuTranslate.Purchases, items: this.getPurchaseMenu(userPermissions)
                        }
                    )
                }
                if (wareHouseMenuPermission) {
                    moreMenu.items.push({ label: this.menuTranslate.Locations, routerLink: ['/locations'] })
                }
                if (isSerialDetails) {
                    moreMenu.items.push({ label: this.menuTranslate.SerialDetails, routerLink: ['/serial-details'] })
                }
                if (isPointOfsale) {
                    moreMenu.items.push({ label: this.menuTranslate.PosStore, routerLink: ['/pos-store'] })
                }
                if (!(opportunityMenuPermission || gaolsMenuPermission || casesMenuPermission)) {//If don't have these module permissions, inventory menus will splited
                    menuItems = [...menuItems, ...moreMenu.items];
                } else {
                    menuItems.push(moreMenu);
                }
            }

            //Finance
            const financeUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.FINANCE);
            const financeMenuPermission = financeUserPermission ? (financeUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

            if (financeMenuPermission) {
                menuItems.push({ label: this.menuTranslate.Finance, routerLink: ['/Finance'] });
            }

            //Misc
            const miscMenu = {
                label: this.menuTranslate.Misc, items: [] as any[]
            }

            //WorkFlow
            const workflowUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.WORKFLOW);
            const workflowMenuPermission = workflowUserPermission ? (workflowUserPermission?.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

            if (workflowMenuPermission) {
                miscMenu.items.push(
                    { label: this.menuTranslate.Workflow, routerLink: ['/workflow'] },
                    // { label: this.menuTranslate.MassEdit, routerLink: ['/massEdit'] },
                )
            }

            // Campaign
            const campaignUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CAMPAIGN);
            const campaignMenuPermission = campaignUserPermission ? (campaignUserPermission?.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

            if (campaignMenuPermission) {
                miscMenu.items.push(
                    { label: this.menuTranslate.Campaign, routerLink: ['/messaging'] }
                )
            }

            //SavedSearch
            const savedSearchUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.SavedSearch);
            const savedSearchMenuPermission = savedSearchUserPermission ? (savedSearchUserPermission?.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

            if (savedSearchMenuPermission) {
                miscMenu.items.push(
                    { label: this.menuTranslate.SavedSearches, routerLink: ['/saved-searches'] }
                )
            }

            //Workspace
            const workspaceUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.WORKSPACES);
            const workspaceMenuPermission = workspaceUserPermission ? (workspaceUserPermission?.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

            if(workspaceMenuPermission){
                miscMenu.items.push(
                    { label: this.menuTranslate.Workspace, routerLink: ['/workspace'] }
                )    
            }
            if (miscMenu?.items?.length > 0) {
                if (!(accountMenuPermission)) {//If don't have these module permissions, menus will be splited
                    menuItems = [...menuItems, ...miscMenu.items];
                } else {
                    menuItems.push(miscMenu);
                }
            }

            const tasksUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.TASK);
            const tasksMenuPermission = tasksUserPermission ? (tasksUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;
           
            if (reportPermission) {
                menuItems.push({ label: this.menuTranslate.Reports, routerLink: ['/reports'] });
            }

            const configurationUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CONFIGURATION);
            const configurationMenuPermission = configurationUserPermission ? (configurationUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;
            if (configurationMenuPermission) {
                menuItems.push({ label: this.menuTranslate.Configurations, routerLink: ['/configurations'] });
            }

            this.menu = menuItems.length ? [...menuItems] : [];
        });

        this.configurationService.getUserPermissionsReport(this.app.user.userId).then(res => {

            this.permissionService.userReportsPermissionsBSubject.next(res);
            const reportPermissions = this.permissionService.getReportsPermissionByChannel();
            const reportPermission = reportPermissions?.find(report => report?.permissions.find(obj => obj.statusId == 1));
            const userPermissions = this.permissionService.getPemrissionData();
            if (reportPermissions.length > 0)
                this.app.setDashboardWidgets(reportPermissions, userPermissions);

            const reportMenu = this.menu.find(menu => menu.label === this.menuTranslate.Reports);

            if (reportPermission && !reportMenu) {
                const configPermissionIndex = this.menu.findIndex(menu => menu.label === this.menuTranslate.Configurations);
                const reportMenu = { label: this.menuTranslate.Reports, routerLink: ['/reports'] };

                if (configPermissionIndex >= 0) {
                    this.menu.splice(configPermissionIndex, 0, reportMenu)
                } else {
                    this.menu.push(reportMenu)
                }
            }

        });

    }

    private updateMenuWithWorkbooks(moduleWidgets: DynamicTableModuleWidgetM[]) {
        if(moduleWidgets.length > 0){
            moduleWidgets = [...moduleWidgets.filter(moduleWidget => moduleWidget.permissionType !== 0)];
        }
        else{
            return;
        }
        
        // Remove existing Custom menu if it exists
        const existingCustomIndex = this.menu.findIndex(menu => menu.label === 'Custom');
        if (existingCustomIndex >= 0) {
            this.menu.splice(existingCustomIndex, 1);
        }

        if (!moduleWidgets || moduleWidgets.length === 0) {
            return;
        }

        // Create customModulesMenu items
        const customModulesMenu = {
            label: 'Custom',
            items: moduleWidgets
              .map(moduleWidget => ({
                label: moduleWidget.name,
                routerLink: ['/custom-module', moduleWidget.referenceId],
                state: { workbook: moduleWidget },
                command: () => { 
                    this.app.selectedOrder = moduleWidget.name;
                }
              }))
        };

        // Always add Custom menu at the end for consistent positioning
        this.menu.push(customModulesMenu);
    }

    getProductMenu(userPermissions) {
        const productMenu = [
            { label: 'Inventory Item', objectName: ObjectNames.Inventory_Item, routerLink: ['/inventory-items'], command: () => { this.app.selectedOrder = 'Inventory Item' } },
            { label: 'Service', objectName: ObjectNames.Service_Item, routerLink: ['/services'], command: () => { this.app.selectedOrder = 'Service' } },
            { label: 'Non Inventory Item', objectName: ObjectNames.Non_Inventory_Item, routerLink: ['/non-inventory'], command: () => { this.app.selectedOrder = 'Non-Inventory Item' } },
            { label: 'Bundle Item', objectName: ObjectNames.Bundle_Item, routerLink: ['/bundle-items'], command: () => { this.app.selectedOrder = 'Bundle Item' } },
            { label: 'Kit/Package Items', objectName: ObjectNames.Kit_Items, routerLink: ['/kit-items'], command: () => { this.app.selectedOrder = 'Kit/Package Items' } }
        ]
        return productMenu.filter(menuItem => userPermissions.some(mainItem => mainItem.objectName === menuItem.objectName && mainItem.permissions.some(permission => permission.statusId === 1)));
    }

    getPurchaseMenu(userPermissions) {
        const purchaseMenu = [
            { label: 'Purchase Order', objectName: ObjectNames.PURCHASE, routerLink: ['/purchase-order'], command: () => { this.app.selectedOrder = 'Purchase Order' } },
            { label: 'Item Receipt', objectName: ObjectNames.Item_Receipt, routerLink: ['/item-receipt'], command: () => { this.app.selectedOrder = 'Item Receipt' } },
            { label: 'Bill', objectName: ObjectNames.Bill, routerLink: ['/bill'], command: () => { this.app.selectedOrder = 'Bill' } },
            { label: 'Payment Receipts', objectName: ObjectNames.Bill_Payment, routerLink: ['/payment-receipt'], command: () => { this.app.selectedOrder = 'Bill Payment' } },
            { label: 'Vendors', objectName: ObjectNames.Vendor, routerLink: ['/vendors'], command: () => { this.app.selectedOrder = 'Vendors' } },
            { label: 'Vendor Returns', objectName: ObjectNames.Vendor_Returns, routerLink: ['/vendor-return'], command: () => { this.app.selectedOrder = 'Vendor Returns' } },
            { label: 'Vendor Credit', objectName: ObjectNames.Vendor_Credit, routerLink: ['/vendor-credit'], command: () => { this.app.selectedOrder = 'Vendor Credit' } },
        ]
        return purchaseMenu.filter(menuItem => userPermissions.some(mainItem => mainItem.objectName === menuItem.objectName && mainItem.permissions.some(permission => permission.statusId === 1)));
    }

    getSubMenu(userPermissions) {
        const subMenu = [];
        const salesOrderUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.SALES_ORDER &&
            obj.permissions.some(permission => permission.statusId === 1));
        const estimateUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.Est_Menu_Object &&
            obj.permissions.some(permission => permission.statusId === 1));
        const invoiceUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.INVOICE &&
            obj.permissions.some(permission => permission.statusId === 1));
        const customerRMAUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CustomerRMA &&
            obj.permissions.some(permission => permission.statusId === 1));
        const creditMemoUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CM_Menu_Object &&
            obj.permissions.some(permission => permission.statusId === 1));
        const salesReceiptPermission = userPermissions.find(obj => obj.objectName === ObjectNames.RECEIVE_PAYMENT &&
            obj.permissions.some(permission => permission.statusId === 1));
        const permissionObjects = [
            { permission: estimateUserPermission, label: 'Estimates', routerLink: ['/estimates'], selectedOrder: 'Estimates' },
            { permission: salesOrderUserPermission, label: 'Sales Order', routerLink: ['/sales-order'], selectedOrder: 'Sales Order' },
            { permission: invoiceUserPermission, label: 'Invoicing', routerLink: ['/invoicing'], selectedOrder: 'Invoicing' },
            { permission: salesReceiptPermission, label: 'Sales Receipt', routerLink: ['/sales-receipt'], selectedOrder: 'Sales Receipt' },
            { permission: customerRMAUserPermission, label: 'Customer Returns', routerLink: ['/customer-returns'], selectedOrder: 'Customer Returns' },
            { permission: creditMemoUserPermission, label: 'Credit Memo', routerLink: ['/credit-memo'], selectedOrder: 'Credit Memo' }
        ];

        permissionObjects.forEach(permissionObj => {
            if (permissionObj.permission) {
                subMenu.push({
                    label: permissionObj.label,
                    routerLink: permissionObj.routerLink,
                    command: () => { this.app.selectedOrder = permissionObj.selectedOrder }
                });
            }
        });
        return subMenu;
    }

    ngOnDestroy() {
        if (this.userPermissionSubscription) {
            this.userPermissionSubscription.unsubscribe();
        }
        if (this.moduleWidgetSubscription) {
            this.moduleWidgetSubscription.unsubscribe();
        }
    }
}
